import React from 'react';
import { cn } from '../../lib/utils';
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-muted', className)} {...props} data-id="element-2861" />;
}
export { Skeleton };